export * from './numeros';
export * from './datas';
export * from './mascaras';
export * from './texto'

const constantes = Object.freeze({
  LOCALE: 'pt-BR',
  BASE_URL: window.location.protocol+'//'+window.location.host
});


async function getEnv() {
  try {
    let data = await fetch(`${constantes.BASE_URL}/env.json`, {
      mode: "no-cors",
    });
    let result = data.json();
    return result;
  } catch (err) {
    console.log(err);
  }
}

async function getVersion() {
  try {
    let data = await fetch(`${constantes.BASE_URL}/version.json`, {
      mode: "no-cors",
    });
    let result = data.json();
    return result;
  } catch (err) {
    console.log(err);
  }
}

const isMobile = () => {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return true
  } else {
      return false
  }
}

const showToast = (el, titulo, mensagem, variant) => {
  el.$bvToast.toast(mensagem, {
    title: titulo,
    variant: variant,
    solid: true
  });
}

const downloadFile = (blob, fileName) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();  
}


const ocultarLetras = (valor) => {
  if(valor){
    var nome = valor.split(" ");
    for (let i = 0; i < nome.length; i++) {
      var primeiraLetra = nome[i].substr(0, 1);
      var letrasOcultadas = "";
      [...nome[i].substr(1)].forEach((letra) => {
        letra = letra.replace(letra, "*");
        letrasOcultadas = letrasOcultadas + letra;
      });
      nome[i] = primeiraLetra + letrasOcultadas;
    }
    return nome.join(" ");
  }
}

const scrollToTop = () => {
  document.documentElement.scrollTop = 0;
}

export default {
  getEnv, getVersion,isMobile,downloadFile,showToast,ocultarLetras,scrollToTop
}
